import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { useContent } from "../hooks/useContent";
import { useSeo } from "../components/SEO";
import PageHero from "../components/PageHero";
import { Section } from "../components/Primitives";
import { Sun, Coffee, UtensilsCrossed, Sparkles, Moon } from "lucide-react";

const DAYICONS = [Sun, Coffee, UtensilsCrossed, Sparkles, Moon];

export default function MilieuDeVie() {
  const { t, pick } = useI18n();
  useSeo(t("nav.milieu"), "Un milieu de vie chaleureux et lumineux à Laval : espaces communs, jardin, repas conviviaux et journée type.");
  const { data: gallery = [] } = useContent("gallery");

  return (
    <>
      <PageHero eyebrow={t("nav.milieu")} title={t("home.milieuTitle")} subtitle={t("home.milieuBody")}
        image="https://images.pexels.com/photos/7729133/pexels-photo-7729133.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" />

      <Section tone="surface" data-testid="journee-full">
        <h2 className="font-display text-3xl sm:text-4xl">{t("home.journeeTitle")}</h2>
        <ol className="mt-8 space-y-4 border-l-2 border-[#2A9D8F]/25 pl-6">
          {t("home.journee").map((j, i) => {
            const Icon = DAYICONS[i] || Sun;
            return (
              <li key={j.h} className="relative">
                <span className="absolute -left-[38px] flex h-8 w-8 items-center justify-center rounded-full bg-[#2A9D8F] text-white">
                  <Icon className="h-4 w-4" />
                </span>
                <p className="font-display text-lg">{j.h}</p>
                <p className="text-[15px] text-[#5C6370]">{j.d}</p>
              </li>
            );
          })}
        </ol>
      </Section>

      <Section tone="base">
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {gallery.filter((g) => g.image).slice(0, 6).map((g) => (
            <img key={g.id} src={g.image} alt={pick(g.caption)} loading="lazy"
              className="aspect-[4/3] w-full rounded-2xl object-cover" />
          ))}
        </div>
      </Section>
    </>
  );
}
